import { useNavigate } from "react-router-dom";

const C = {
  bg:      "#020c12",
  card:    "rgba(4,16,24,0.90)",
  border:  "rgba(0,229,255,0.10)",
  cyan:    "#00e5ff",
  cyanDim: "rgba(0,229,255,0.4)",
  text:    "#e0f7fa",
  muted:   "rgba(100,180,200,0.5)",
  green:   "#00e676",
  gold:    "#ffd600",
  orange:  "#ff9100",
};

const tradingPlans = [
  { range: "5% – 10%",   label: "Monthly",  risk: "Very Low (Near Risk-Free)", icon: "🔹", riskColor: C.green },
  { range: "10% – 15%",  label: "Monthly",  risk: "Minimal Risk",              icon: "🔹", riskColor: "#69f0ae" },
  { range: "15% – 20%",  label: "Monthly",  risk: "Balanced Risk",             icon: "📈", riskColor: C.gold },
  { range: "20% – 25%",  label: "Monthly",  risk: "Aggressive Risk",           icon: "🔥", riskColor: C.orange },
];

const referralLevels = [
  { level: 1, pct: "10%" },
  { level: 2, pct: "7%"  },
  { level: 3, pct: "5%"  },
  { level: 4, pct: "3%"  },
];

const promotionBonuses = [
  { business: "$1,000",     bonus: "$20"     },
  { business: "$2,500",     bonus: "$40"     },
  { business: "$5,000",     bonus: "$80"     },
  { business: "$10,000",    bonus: "$200"    },
  { business: "$25,000",    bonus: "$500"    },
  { business: "$50,000",    bonus: "$1,000"  },
  { business: "$100,000",   bonus: "$2,500"  },
  { business: "$250,000",   bonus: "$5,000"  },
  { business: "$500,000",   bonus: "$10,000" },
  { business: "$1,000,000", bonus: "$25,000" },
];

export default function CommissionDetail() {
  const navigate = useNavigate();

  return (
    <div style={s.root}>
      <div style={s.grid} />
      <div style={s.glowTL} />
      <div style={s.glowBR} />

      <div style={s.container}>

        {/* ── Header ── */}
        <div style={s.header}>
          <button style={s.backBtn} onClick={() => navigate("/Promotion")}>‹</button>
          <div style={s.titleWrap}>
            <span style={s.titleIcon}>💰</span>
            <h1 style={s.title}>Commission Detail</h1>
          </div>
        </div>

        {/* ── Brand tag ── */}
        <div style={s.brandCard}>
          <span style={s.brandIcon}>🚀</span>
          <div>
            <p style={s.brandName}>WAKWAC</p>
            <p style={s.brandSub}>Trading & Affiliate System</p>
          </div>
        </div>

        {/* ── Trading Plans ── */}
        <Section icon="📊" title="Trading Profit Plans">
          <p style={s.sectionNote}>Compounding Available</p>
          {tradingPlans.map((plan, i) => (
            <div key={i} style={{ ...s.planRow, ...(i === tradingPlans.length - 1 ? { borderBottom: "none" } : {}) }}>
              <div style={s.planLeft}>
                <span style={s.planIcon}>{plan.icon}</span>
                <span style={{ ...s.planRange, color: C.cyan }}>{plan.range}</span>
                <span style={s.planLabel}>{plan.label}</span>
              </div>
              <span style={{ ...s.planRisk, color: plan.riskColor }}>{plan.risk}</span>
            </div>
          ))}
        </Section>

        {/* ── Capital Rule ── */}
        <Section icon="💼" title="Capital Withdrawal Rule">
          <InfoRow icon="✅" text="100% withdrawal available anytime" last />
        </Section>

        {/* ── Signup Bonus ── */}
        <Section icon="🎁" title="Affiliate Program">
          <InfoRow icon="💵" text="$100 Signup Bonus" />
          <InfoRow icon="📌" text="Bonus activates after 11 referrals" />
          <InfoRow icon="📌" text="Min. $10 self deposit for trading withdrawal" />
          <InfoRow icon="📌" text="Need 3 active members ($100 each)" last />
        </Section>

        {/* ── Referral Bonus ── */}
        <Section icon="🤝" title="Referral Bonus (Trade Fund)">
          {referralLevels.map((lvl, i) => (
            <div key={lvl.level} style={{ ...s.refRow, ...(i === referralLevels.length - 1 ? { borderBottom: "none" } : {}) }}>
              <div style={s.refLeft}>
                <span style={s.refBadge}>L{lvl.level}</span>
                <span style={s.refLabel}>Level {lvl.level}</span>
              </div>
              <span style={s.refPct}>{lvl.pct}</span>
            </div>
          ))}
        </Section>

        {/* ── Promotion Bonus ── */}
        <Section icon="🎯" title="Promotion Bonus (Weekly)">
          <div style={s.promoGrid}>
            <div style={s.promoHeadRow}>
              <span style={s.promoHead}>Team Business</span>
              <span style={s.promoHead}>Weekly Bonus</span>
            </div>
            {promotionBonuses.map((row, i) => (
              <div key={i} style={{ ...s.promoRow, ...(i % 2 === 0 ? s.promoRowAlt : {}) }}>
                <span style={s.promoBiz}>{row.business}</span>
                <span style={s.promoBonus}>{row.bonus}</span>
              </div>
            ))}
          </div>
        </Section>

        {/* ── Business Rule ── */}
        <Section icon="📊" title="Business Rule & Weekly Income">
          <InfoRow icon="👉" text="3+ active referrals required" />
          <InfoRow icon="👉" text="Total team business counted weekly" />
          <InfoRow icon="👉" text="Weekly salary continuously generated" />
          <InfoRow icon="📈" text="Consistent business growth is important" last />
        </Section>

        {/* ── Account Setup ── */}
        <Section icon="🔐" title="Account Setup">
          <InfoRow icon="✔️" text="Signup with Email + Mobile Number" />
          <InfoRow icon="✔️" text="Deposit via BEP20 / TRC20" last />
        </Section>

      </div>

      <style>{`
        @keyframes fadeUp { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
}

function Section({ icon, title, children }) {
  return (
    <div style={s.section}>
      <div style={s.sectionHeader}>
        <span style={s.sectionIcon}>{icon}</span>
        <span style={s.sectionTitle}>{title}</span>
      </div>
      {children}
    </div>
  );
}

function InfoRow({ icon, text, last }) {
  return (
    <div style={{ ...s.infoRow, ...(last ? { borderBottom: "none" } : {}) }}>
      <span style={s.infoIcon}>{icon}</span>
      <span style={s.infoText}>{text}</span>
    </div>
  );
}

const s = {
  root: {
    minHeight: "100vh", background: C.bg, fontFamily: "'Sora',sans-serif",
    position: "relative", overflow: "hidden", paddingBottom: 100,
  },
  grid: {
    position: "fixed", inset: 0, pointerEvents: "none",
    backgroundImage: "linear-gradient(rgba(0,229,255,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(0,229,255,0.03) 1px,transparent 1px)",
    backgroundSize: "44px 44px",
  },
  glowTL: {
    position: "fixed", top: -150, left: -100, width: 480, height: 480,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle,rgba(0,229,255,0.08) 0%,transparent 70%)",
  },
  glowBR: {
    position: "fixed", bottom: -100, right: -80, width: 380, height: 380,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle,rgba(0,180,200,0.05) 0%,transparent 70%)",
  },
  container: {
    maxWidth: 480, margin: "0 auto", padding: "24px 16px 40px",
    position: "relative", zIndex: 10,
    animation: "fadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both",
  },

  header: { display: "flex", alignItems: "center", gap: 14, marginBottom: 20 },
  backBtn: {
    background: "rgba(0,229,255,0.08)", border: "1px solid rgba(0,229,255,0.2)",
    color: C.cyan, borderRadius: 10, width: 36, height: 36,
    fontSize: 20, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0,
  },
  titleWrap: { display: "flex", alignItems: "center", gap: 10 },
  titleIcon: { fontSize: 20 },
  title: { fontSize: 20, fontWeight: 700, color: C.text, letterSpacing: "-0.02em" },

  brandCard: {
    display: "flex", alignItems: "center", gap: 14,
    background: "linear-gradient(135deg,rgba(0,229,255,0.07) 0%,rgba(0,180,200,0.03) 100%)",
    border: "1px solid rgba(0,229,255,0.2)", borderRadius: 16,
    padding: "14px 18px", marginBottom: 14,
  },
  brandIcon: { fontSize: 28 },
  brandName: { fontSize: 16, fontWeight: 700, color: C.cyan, letterSpacing: "0.04em" },
  brandSub:  { fontSize: 11, color: C.muted, marginTop: 2 },

  section: {
    background: C.card, border: `1px solid ${C.border}`,
    borderRadius: 18, overflow: "hidden",
    backdropFilter: "blur(20px)", marginBottom: 12,
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
  },
  sectionHeader: {
    display: "flex", alignItems: "center", gap: 10,
    padding: "13px 18px 11px", borderBottom: `1px solid ${C.border}`,
    background: "rgba(0,229,255,0.025)",
  },
  sectionIcon:  { fontSize: 15 },
  sectionTitle: { fontSize: 13, fontWeight: 600, color: C.text },
  sectionNote:  { fontSize: 10, color: C.cyanDim, padding: "8px 18px 4px", fontStyle: "italic" },

  planRow: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "12px 18px", borderBottom: "1px solid rgba(0,229,255,0.05)",
    flexWrap: "wrap", gap: 4,
  },
  planLeft:  { display: "flex", alignItems: "center", gap: 8 },
  planIcon:  { fontSize: 14 },
  planRange: { fontSize: 14, fontWeight: 700, fontFamily: "'Space Mono',monospace" },
  planLabel: { fontSize: 10, color: C.muted },
  planRisk:  { fontSize: 10, fontWeight: 600 },

  infoRow: {
    display: "flex", alignItems: "flex-start", gap: 10,
    padding: "12px 18px", borderBottom: "1px solid rgba(0,229,255,0.05)",
  },
  infoIcon: { fontSize: 13, flexShrink: 0, marginTop: 1 },
  infoText: { fontSize: 12, color: C.text, lineHeight: 1.5 },

  refRow: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "13px 18px", borderBottom: "1px solid rgba(0,229,255,0.05)",
  },
  refLeft:  { display: "flex", alignItems: "center", gap: 12 },
  refBadge: {
    background: "rgba(0,229,255,0.1)", border: "1px solid rgba(0,229,255,0.25)",
    color: C.cyan, borderRadius: 6, padding: "2px 8px",
    fontSize: 10, fontFamily: "'Space Mono',monospace", fontWeight: 700,
  },
  refLabel: { fontSize: 12, color: C.muted },
  refPct:   { fontSize: 16, fontWeight: 700, color: C.cyan, fontFamily: "'Space Mono',monospace" },

  promoGrid: { padding: "0 0 4px" },
  promoHeadRow: {
    display: "flex", justifyContent: "space-between",
    padding: "8px 18px", borderBottom: "1px solid rgba(0,229,255,0.08)",
  },
  promoHead: { fontSize: 9, color: C.cyanDim, fontFamily: "'Space Mono',monospace", letterSpacing: "0.12em", textTransform: "uppercase" },
  promoRow: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "10px 18px",
  },
  promoRowAlt: { background: "rgba(0,229,255,0.015)" },
  promoBiz:   { fontSize: 12, color: C.muted, fontFamily: "'Space Mono',monospace" },
  promoBonus: { fontSize: 13, fontWeight: 700, color: C.green, fontFamily: "'Space Mono',monospace" },
};
